import _ from 'lodash';
import Promise from 'bluebird';

export default (parsers) => {
  const Parser = {};

  Parser.s = parsers;

  Parser.parse = (args) => {
    const checkThenParse = (parser, parserName) => {
      // model name is from first char to the char before first '-'
      const getModelName = postData =>
        ({ ...postData, modelName: parserName.split('-')[0] });

      return Promise.resolve(args)
        .then(parser.check)
        .then(parser.parse)
        .then(getModelName);
    };

    const parsingPromises = _.map(parsers, checkThenParse);

    return Promise.any(parsingPromises);
  };

  return Parser;
};
